import Button from '../../../../../component/ui/Button';
import { getDate } from '../../../../../utils/dateUtils';
import { numberToWords } from '../../../../../utils/helper';
import SalesReturnTabs from './salesReturnTabs';

function SalesReturnPdfView({ settleRefundAmount, returnDetails, setIsDrawerOpen, setDrawerType }) {
	const {
		customer,
		return_number,
		date,
		organisation,
		bill_total,
		sub_total,
		sales_return_invoices,
	} = returnDetails || {};

	return (
		<div
			style={{
				overflowY: 'auto',
				height: '100vh',
				flex: 1,
				padding: '15px 0',
			}}
		>
			{returnDetails && (
				<div className="invoice-container">
					{/* Header Section */}
					<div className="invoice-header">
						<div>
							<h2 style={{ fontSize: '22px', fontWeight: 'bold', color: '#0F1C35' }}>
								{organisation?.organisation_name}
							</h2>
							<div style={{ marginTop: '15px', color: '#555B67' }}>
								<p>{`${organisation?.address?.state?.name || 'N/A'}`}</p>
								<p>{`${organisation?.address?.country?.name || 'N/A'}`}</p>
								{/* <p>{`${phone_mobile || 'N/A'} | ${email || 'N/A'}`}</p> */}
							</div>
						</div>
						<div className="bill-status">
							<h2 style={{ fontSize: '30px', fontWeight: 'bold' }}>Sales Return</h2>
						</div>
					</div>

					{/* Invoice Details */}
					<div
						style={{
							display: 'flex',
							gap: '60px',
							fontFamily: 'Arial',
							fontSize: '15px',
							color: '#000',
							border: '1px solid #ddd',
							padding: '13px',
						}}
					>
						{/* Left Column (Labels) */}
						<div
							style={{ display: 'flex', flexDirection: 'column', gap: '10px', color: '#555B67' }}
						>
							<span>Sales Return #</span>
							<span>Return Date</span>
						</div>

						{/* Right Column (Values) */}
						<div style={{ display: 'flex', flexDirection: 'column', gap: '10px', fontWeight: 700 }}>
							<span>: {return_number}</span>
							<span>: {getDate(date)}</span>
						</div>
					</div>

					{/* Bill To Section */}
					<div
						style={{
							display: 'flex',
							border: '1px solid #ddd',
							padding: '13px',
							alignItems: 'center',
							justifyContent: 'space-between',
						}}
					>
						<div className="bill-to">
							<p style={{ color: '#0F1C35', fontSize: '16px', fontWeight: '600' }}>Bill To:</p>
							<h3
								style={{
									fontWeight: 'bold',
									color: '#3B58FF',
									fontSize: '14px',
									cursor: 'pointer',
								}}
								onClick={() => {
									setDrawerType('customer');
									setIsDrawerOpen(true);
								}}
							>
								{customer?.name}
							</h3>
							<div style={{ marginTop: '15px', color: '#555B67' }}>
								<p>{`${customer?.street1 || 'N/A'}`}</p>
								<p>{`${customer?.state?.name || 'N/A'}`}</p>
								<p>{`${customer?.country?.name || 'N/A'} - ${customer?.zipcode || 'N/A'}`}</p>
							</div>
						</div>
					</div>
					{/* Items Table */}
					<table className="invoice-table">
						<thead>
							<tr>
								<th>#</th>
								<th>PRODUCT DETAILS</th>
								<th>INVOICE</th>
								<th>MRP</th>
								<th>QNTY</th>
								<th>AMOUNT</th>
							</tr>
						</thead>
						<tbody>
							{sales_return_invoices?.map((item, index) => (
								<tr key={index}>
									<td>{index + 1}</td>
									<td>
										<strong>{item?.product?.product_name}</strong>
										<br />
										<div style={{ display: 'flex', justifyContent: 'space-between' }}>
											<strong style={{ color: 'grey', fontSize: '12px' }}>
												{`${item?.product_batch?.batch_no}`}
												<span
													style={{ color: 'grey', marginLeft: '10px', fontSize: '12px' }}
												>{`${getDate(item.exp, false, false, true)}`}</span>
											</strong>
											<strong style={{ color: 'grey', fontSize: '12px' }}>
												{item?.return_type?.name}
											</strong>
										</div>
									</td>
									<td>{item.invoice?.invoice_number}</td>
									<td>{Number(item.mrp).toFixed(2)}</td>
									<td>
										{item.qty} {item.product?.unit?.key}
									</td>
									<td>{Number(item.amount).toFixed(2)}</td>
								</tr>
							))}
						</tbody>
					</table>

					{/* Total Section */}
					<div className="total-section">
						<div style={{ width: '270px' }}>
							<p style={{ fontSize: '14px', color: '#555B67' }}>Total In Words</p>
							<p
								style={{ fontSize: '14px', color: '#000000', fontWeight: 'bold' }}
							>{`${numberToWords(Number(bill_total))}`}</p>
							<p style={{ fontSize: '14px', color: '#555B67' }}>Note</p>
							<p style={{ fontSize: '14px', color: '#000000', fontWeight: 'bold' }}>
								{returnDetails?.notes || 'N/A'}
							</p>
						</div>
						<div className='d-flex gap-4'>
							<div
								className="totals"
								style={{
									fontSize: '14px',
									fontWeight: 'bold',
									color: '#000000',
									textAlign: 'right',
								}}
							>
								<p>Sub Total </p>
								<p>Total </p>
							</div>
							<div style={{ color: '#555B67', textAlign: 'right' }}>
								<p style={{ fontSize: '14px' }}>
									<b>Rs.</b>
									{Number(sub_total).toFixed(2)}
								</p>
								<p style={{ fontSize: '14px' }}>
									<b>Rs.</b> {Number(bill_total).toFixed(2)}
								</p>
							</div>
						</div>
					</div>

					{/* Footer */}
					<div style={{ textAlign: 'right' }}>
						<p>Authorized Signature: __________________________</p>
					</div>
				</div>
			)}
		</div>
	);
}

export default SalesReturnPdfView;
